import React from 'react'
import {
  Table,
} from 'semantic-ui-react'
import ItemCounter from './ItemCounter.js'

const OptionalItemCounterCell = ({mode, selection, fqidPrefix, itemKind}) => {
  if (mode==='select') {
    return (
      <Table.Cell collapsing textAlign='center'>
        {
          selection
          ?
          <ItemCounter
            type={selection.type}
            items={selection.items}
            fqidPrefix={fqidPrefix}
            itemKind={itemKind}
          />
          :
          null
        }
      </Table.Cell>
    );
  } else {
    return null;
  }
}

export default OptionalItemCounterCell;